import React, { useState } from "react";
import { Modal, Input, Button, Space } from "antd";
import { BoxPlotOutlined } from "@ant-design/icons";
import styles from "./CreateAgentModal.css";
import { Api } from "@/api/api";
import { showSuccess } from "@/utils";
import { useLoading } from "@/components/global-loading";
import { FormattedMessage, injectIntl } from "react-intl";

const CreateAgentModal = ({ open, onOk, onCancel, intl }) => {
    const [agentName, setAgentName] = useState("");
    const { showLoading, hideLoading } = useLoading();

    const handleOk = () => {
        if (agentName.trim() && agentName.length > 0) {
            showLoading(intl.formatMessage({
                id: "gui.agentManage.creating",
                defaultMessage: "Creating..."
            }));
            Api.agent.addAgent(agentName, (res) => {
                showSuccess(intl.formatMessage({
                    id: "gui.agentManage.addSuccess",
                    defaultMessage: "Added successfully"
                }));
                onOk(agentName);
                setAgentName("");
                hideLoading();
            });
        }
    };

    const handleCancel = () => {
        onCancel();
        setAgentName("");
    };

    return (
        <Modal
            open={open}
            onOk={handleOk}
            onCancel={handleCancel}
            width={600}
            className={styles.modalContent}
            destroyOnHidden={true}
            title={
                <div className={styles.titleWrapper}>
                    <img
                        style={{ width: 14, height: "auto" }}
                        src={require("@/assets/agentIcon.png")}
                    />
                    <span className={styles.titleText}>
                        <FormattedMessage
                            id="gui.agentManage.createAgent"
                            defaultMessage="Create Agent"
                        />
                    </span>
                </div>
            }
            footer={
                <div className={styles.footerWrapper}>
                    <Space size={16}>
                        <Button
                            style={{ width: 150 }}
                            type="primary"
                            onClick={handleOk}
                            className={styles.confirmBtn}
                        >
                            <FormattedMessage
                                id="gui.agentManage.confirm"
                                defaultMessage="Confirm"
                            />
                        </Button>
                        <Button
                            style={{ width: 150 }}
                            onClick={handleCancel}
                            className={styles.cancelBtn}
                        >
                            <FormattedMessage
                                id="gui.agentManage.cancel"
                                defaultMessage="Cancel"
                            />
                        </Button>
                    </Space>
                </div>
            }
            closable={false}
        >
            <div className={styles.content}>
                <div className={styles.formItem}>
                    <label className={styles.label}>
                        <span className={styles.required}>*</span>
                        <FormattedMessage
                            id="gui.agentManage.agentNameLabel"
                            defaultMessage="Agent Name:"
                        />
                    </label>
                    <Input
                        placeholder={intl.formatMessage({
                            id: "gui.agentManage.agentNamePlaceholder",
                            defaultMessage: "Please enter agent name"
                        })}
                        value={agentName}
                        onChange={(e) => setAgentName(e.target.value)}
                        className={styles.input}
                        size="large"
                    />
                </div>
            </div>
        </Modal>
    );
};

export default injectIntl(CreateAgentModal);